export const CURRENCIES = [
  { code: "INR", label: "INR – Indian Rupee", symbol: "₹" },
  { code: "USD", label: "USD – US Dollar", symbol: "$" },
  { code: "EUR", label: "EUR – Euro", symbol: "€" },
  { code: "GBP", label: "GBP – British Pound", symbol: "£" },
  { code: "AUD", label: "AUD – Australian Dollar", symbol: "A$" },
  { code: "CAD", label: "CAD – Canadian Dollar", symbol: "C$" },
  { code: "SGD", label: "SGD – Singapore Dollar", symbol: "S$" },
];

export const currencySymbol = (code?: string | null) => {
  const c = (code || "INR").toUpperCase();
  return CURRENCIES.find((x) => x.code === c)?.symbol ?? c;
};

export const formatMoney = (amount: number | string | null | undefined, code?: string | null) => {
  const c = (code || "INR").toUpperCase();
  const n = Number(amount ?? 0) || 0;
  try {
    return new Intl.NumberFormat(c === "INR" ? "en-IN" : "en-US", { style: "currency", currency: c, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
  } catch {
    return `${c} ${n.toFixed(2)}`;
  }
};